import React from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

const getDaySuffix = (day) => {
  if (day >= 11 && day <= 13) return "th";
  switch (day % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

const formatRangeDate = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  const day = date.getDate();
  const month = date.toLocaleDateString("en-US", { month: "long" });
  const year = date.getFullYear();
  return `${day}${getDaySuffix(day)} of ${month}, ${year}`;
};

const capitalize = (str) => (str ? str.charAt(0).toUpperCase() + str.slice(1) : "");

const CancelScheduledUpdateModal = ({ show, onHide, trail, onConfirm, loading }) => {
  if (!trail) return null;

  const days = (trail.days || []).map(capitalize);
  const dayLabel =
    days.length === 0
      ? ""
      : days.length === 1
        ? days[0]
        : days.length === 2
          ? `${days[0]} and ${days[1]}`
          : `${days.slice(0, -1).join(", ")}, and ${days[days.length - 1]}`;
  const actionLabel = trail.action === "activate" ? "activation" : "deactivation";
  let range = "";
  if (trail.startDate && trail.endDate) {
    range = `from ${formatRangeDate(trail.startDate)} to ${formatRangeDate(trail.endDate)}`;
  } else if (trail.startDate) {
    range = `from ${formatRangeDate(trail.startDate)}`;
  } else if (trail.endDate) {
    range = `until ${formatRangeDate(trail.endDate)}`;
  }

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title style={{ color: "#344054", fontWeight: 600 }}>
          Cancel Scheduled Update
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4 py-4">
        <p style={{ color: "#344054", fontSize: "16px", marginBottom: 0 }}>
          Are you sure you want to cancel the scheduled {actionLabel} of {dayLabel} {range}?
        </p>
      </Modal.Body>
      <Modal.Footer className="border-0 px-4 pb-4">
        <Button
          variant="outline-secondary"
          onClick={onHide}
          className="px-4"
          disabled={loading}
        >
          No, don't cancel
        </Button>
        <Button
          variant="danger"
          onClick={onConfirm}
          className="px-4"
          disabled={loading}
        >
          {loading ? <Spinner animation="border" size="sm" /> : "Yes, cancel"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default CancelScheduledUpdateModal;
